export const optionsToValueLabels = (options: {
	[key: string]: string
}): {value: string; label: string}[] =>
	Object.keys(options).map((key) => ({
		value: key,
		label: options[key] as string
	}))
